module.exports = __webpack_public_path__ + "img/sd-bb-b-1.7271ee7f.jpg";